<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-submenu index="2" v-if="permissionCodes.indexOf('034002000') !== -1 || permissionCodes.indexOf('034003000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_bumengangweiguanli"></i>
          <span>部门岗位管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="2-1" @click="toNewRouter('attendance-department-manage')" v-if="permissionCodes.indexOf('034002000') !== -1">部门管理</el-menu-item>
          <el-menu-item index="2-2" @click="toNewRouter('attendance-position-manage')" v-if="permissionCodes.indexOf('034003000') !== -1">岗位管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="3" @click="toNewRouter('attendance-person-manage')" v-if="permissionCodes.indexOf('034004000') !== -1">
        <i class="el-icon-damai-ic_renyuanguanli"></i>
        <span slot="title">人员管理</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('attendance-overtime-manage')" v-if="permissionCodes.indexOf('034005000') !== -1">
        <i class="el-icon-damai-ic_jiabanpeizhi"></i>
        <span slot="title">加班配置</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('attendance-point-manage')" v-if="permissionCodes.indexOf('034006000') !== -1">
        <i class="el-icon-damai-ic_kaoqindianguanli"></i>
        <span slot="title">考勤点管理</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('attendance-team-manage')" v-if="permissionCodes.indexOf('034007000') !== -1">
        <i class="el-icon-damai-ic_banzuguanli"></i>
        <span slot="title">班组管理</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('attendance-frequency-manage')" v-if="permissionCodes.indexOf('034008000') !== -1">
        <i class="el-icon-damai-ic_banciguanli"></i>
        <span slot="title">班次管理</span>
      </el-menu-item>
      <el-menu-item index="8" @click="toNewRouter('attendance-scheduling-manage')" v-if="permissionCodes.indexOf('034009000') !== -1">
        <i class="el-icon-damai-ic_paibanguanli"></i>
        <span slot="title">排班管理</span>
      </el-menu-item>
      <el-menu-item index="9" @click="toNewRouter('attendance-switch-manage')" v-if="permissionCodes.indexOf('034010000') !== -1">
        <i class="el-icon-damai-ic_tiaobanguanli"></i>
        <span slot="title">调班管理</span>
      </el-menu-item>
      <el-submenu index="10" v-if="permissionCodes.indexOf('034011000') !== -1 || permissionCodes.indexOf('034012000') !== -1 || permissionCodes.indexOf('034013000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_kaoqintiaozheng"></i>
          <span>考勤调整</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="10-1" @click="toNewRouter('attendance-overtime-application-manage')" v-if="permissionCodes.indexOf('034011000') !== -1">加班申请</el-menu-item>
          <el-menu-item index="10-2" @click="toNewRouter('attendance-repair-application-manage')" v-if="permissionCodes.indexOf('034012000') !== -1">补卡申请</el-menu-item>
          <el-menu-item index="10-3" @click="toNewRouter('attendance-adjust-manage')" v-if="permissionCodes.indexOf('034013000') !== -1">请假调休</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="11" @click="toNewRouter('attendance-vacation-manage')" v-if="permissionCodes.indexOf('034014000') !== -1">
        <i class="el-icon-damai-ic_jiaqiguanli"></i>
        <span slot="title">假期管理</span>
      </el-menu-item>
      <el-menu-item index="16" @click="toNewRouter('attendance-punch-record-manage')" v-if="permissionCodes.indexOf('034019000') !== -1">
        <i class="el-icon-damai-ic_dakajilu"></i>
        <span slot="title">打卡记录</span>
      </el-menu-item>
      <el-menu-item index="12" @click="toNewRouter('attendance-record-manage')" v-if="permissionCodes.indexOf('034015000') !== -1">
        <i class="el-icon-damai-ic_kaoqinjilu"></i>
        <span slot="title">考勤记录</span>
      </el-menu-item>
      <el-menu-item index="15" @click="toNewRouter('attendance-salary-report')" v-if="permissionCodes.indexOf('034018000') !== -1">
        <i class="el-icon-damai-ic_kaoqinbaobiao"></i>
        <span slot="title">考勤报表</span>
      </el-menu-item>
      <el-menu-item index="13" @click="toNewRouter('attendance-report-manage')" v-if="permissionCodes.indexOf('034016000') !== -1">
        <i class="el-icon-damai-ic_xinchoubaobiao"></i>
        <span slot="title">薪酬报表</span>
      </el-menu-item>
      <el-menu-item index="17" @click="toNewRouter('attendance-config')" v-if="permissionCodes.indexOf('034020000') !== -1">
        <i class="el-icon-damai-ic_kaoqinpeizhi"></i>
        <span slot="title">考勤配置</span>
      </el-menu-item>
      <el-menu-item index="14" @click="toNewRouter('work-attendance-log')" v-if="permissionCodes.indexOf('034017000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  "2-1": [
    "attendance-department-manage",
    "attendance-department-add",
    "attendance-department-modify"
  ],
  "2-2": [
    "attendance-position-manage",
    "attendance-position-add",
    "attendance-position-modify"
  ],
  "3": [
    "attendance-person-manage",
    "attendance-person-add",
    "attendance-person-modify"
  ],
  "4": [
    "attendance-overtime-manage",
    "attendance-overtime-add",
    "attendance-overtime-modify"
  ],
  "5": [
    "attendance-point-manage",
    "attendance-point-add",
    "attendance-point-modify"
  ],
  "6": [
    "attendance-team-manage",
    "attendance-team-add",
    "attendance-team-modify"
  ],
  "7": [
    "attendance-frequency-manage",
    "attendance-frequency-add",
    "attendance-frequency-modify"
  ],
  "8": [
    "attendance-scheduling-manage",
    "attendance-scheduling-add",
    "attendance-scheduling-rank",
    "attendance-scheduling-rank-detail"
  ],
  "9": [
    "attendance-switch-manage",
    "attendance-switch-add",
    "attendance-switch-modify"
  ],
  "10-1": [
    "attendance-overtime-application-manage",
    "attendance-overtime-application-add",
    "attendance-overtime-application-modify"
  ],
  "10-2": [
    "attendance-repair-application-manage",
    "attendance-repair-application-add",
    "attendance-repair-application-modify"
  ],
  "10-3": [
    "attendance-adjust-manage",
    "attendance-adjust-add",
    "attendance-adjust-modify"
  ],
  "11": [
    "attendance-vacation-manage",
    "attendance-vacation-add",
    "attendance-vacation-modify"
  ],
  "12": ["attendance-record-manage"],
  "13": ["attendance-report-manage"],
  "14": ["work-attendance-log"],
  '15': ['attendance-salary-report'],
  '16': ['attendance-punch-record-manage'],
  '17': ['attendance-config']
});

export default {
  name: "investment-leasing-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/WorkAttendance/WorkAttendanceNav.vue